import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    siteId: String
  }

  static targets = ["markAllDisposedButton", "itemCount", "workspaceSelect", "supplierSelect"]

  initialize() {
    this.checkedIds = new Set();
  }

  connect() {
    this._hasWorkspaceChanges = false
    this._hasSupplierChanges = false

    this._boundWorkspaceChange = () => { this._hasWorkspaceChanges = true }
    this._boundWorkspaceHidden = () => {
      if (this._hasWorkspaceChanges) this.element.requestSubmit()
      this._hasWorkspaceChanges = false
    }
    this._boundSupplierChange = () => { this._hasSupplierChanges = true }
    this._boundSupplierHidden = () => {
      if (this._hasSupplierChanges) this.element.requestSubmit()
      this._hasSupplierChanges = false
    }

    if (this.hasWorkspaceSelectTarget) {
      $(this.workspaceSelectTarget)
        .on('change.bs.select', this._boundWorkspaceChange)
        .on('hidden.bs.select', this._boundWorkspaceHidden)
    }

    if (this.hasSupplierSelectTarget) {
      $(this.supplierSelectTarget)
        .on('change.bs.select', this._boundSupplierChange)
        .on('hidden.bs.select', this._boundSupplierHidden)
    }
  }

  disconnect() {
    if (this.hasWorkspaceSelectTarget) {
      $(this.workspaceSelectTarget)
        .off('change.bs.select', this._boundWorkspaceChange)
        .off('hidden.bs.select', this._boundWorkspaceHidden)
    }

    if (this.hasSupplierSelectTarget) {
      $(this.supplierSelectTarget)
        .off('change.bs.select', this._boundSupplierChange)
        .off('hidden.bs.select', this._boundSupplierHidden)
    }
  }

  print() {
    setTimeout(window.print, 250)
  }

  clearFilters() {
    if (this.hasWorkspaceSelectTarget) $(this.workspaceSelectTarget).selectpicker('deselectAll')
    if (this.hasSupplierSelectTarget) $(this.supplierSelectTarget).selectpicker('deselectAll')
    this.element.requestSubmit()
  }

  checkedRows(event) {
    this.checkedIds = event.detail.ids;
    this.itemCountTarget.innerHTML = [...this.element.querySelectorAll('tbody tr')].filter((row) => row.querySelector('[data-turbotable-id-param]:checked')).map((row) => parseInt(row.querySelector('td.item-quantity').textContent)).reduce((acc, value) => acc + value, 0);
    this.markAllDisposedButtonTarget.classList.toggle('d-none', this.checkedIds.size === 0);
  }

  markAllExpiredDisposedModal(event) {
    event.preventDefault();
    const ids = Array.from(this.checkedIds)
    const site_id = this.siteIdValue
    if (ids.length) {
      document.getElementById('turbo-modal').src = `/sites/${site_id}/mark_expired_items_disposed_modal/?alert_ids=${ids}`
    }
  }
}
